// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.__search{
  display: grid;
  grid-template-columns: 310px 1fr;
  font-size: var(--title);
  margin-top: 5px;
  gap: 12px;
}
@media (min-height: 768px) {
  .__search{
    display: grid;
    grid-template-columns: 310px 1fr;
    height: 100%;
    margin-top: 5px;
    gap: 12px;
  }
}
.__search__filters{
  box-shadow: 0px 4.8px 14.4px rgba(0, 0, 0, 0.18);
  border-radius: 4px;
  text-align: left;
  height: fit-content;
  background: #ffffff;
  padding-bottom: 8px;
}
.__search__grid{
  box-shadow: 0px 4.8px 14.4px rgba(0, 0, 0, 0.18);
  border-radius: 4px;
  text-align: left;
  height: fit-content;
  overflow-x: auto;
  overflow-y: hidden;
  background: #ffffff;
  min-width: 0;
}
.__search__grid--container{
  padding-bottom: 1px;
}
.__search__grid--container-title{
  font-weight: 600;
  font-size: var(--title);
  line-height: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #000;
  margin: 0;
  padding: 10px 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}
@media (min-height: 768px) {
  .__search__grid--container-title{
    font-family: Segoe UI;
    font-weight: 600;
    font-size: var(--subheader);
    line-height: 20px;
    display: flex;
    align-items: center;
    color: #000;
    margin: 0;
    padding: 10px 12px;
  }
}
.__search__grid--container-freeAcion{
  display: flex;
  align-items: flex-end;
}
.__search__grid--container-dateRange{
  margin-right: 12px;
  font-size: 16px;
}
.__search__grid--container__Grid{
  height: 82%;
  overflow: hidden;
}
@media (min-height: 768px) {
  .__search__grid--container__Grid{
    height: 92%;
    overflow: hidden;
  }
}
.dialog.delete-rule div {
  position: static !important;
  top: auto !important;
  left: auto !important;
}
.dialog.delete-rule {
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  min-height: 100vh;
}
.__search__circular {
  color: var(--primary);
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -10px 0 0 -10px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Modules/RulesConfiguration/components/searchTab/SearchTab.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gCAAgC;EAChC,uBAAuB;EACvB,eAAe;EACf,SAAS;AACX;AACA;EACE;IACE,aAAa;IACb,gCAAgC;IAChC,YAAY;IACZ,eAAe;IACf,SAAS;EACX;AACF;AACA;EACE,gDAAgD;EAChD,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,gDAAgD;EAChD,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,4CAA4C;AAC9C;AACA;EACE;IACE,qBAAqB;IACrB,gBAAgB;IAChB,2BAA2B;IAC3B,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,SAAS;IACT,kBAAkB;EACpB;AACF;AACA;EACE,aAAa;EACb,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;AACA;EACE,2BAA2B;EAC3B,oBAAoB;EACpB,qBAAqB;AACvB;AACA;EACE,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,uBAAuB;AACzB","sourcesContent":[".__search{\n  display: grid;\n  grid-template-columns: 310px 1fr;\n  font-size: var(--title);\n  margin-top: 5px;\n  gap: 12px;\n}\n@media (min-height: 768px) {\n  .__search{\n    display: grid;\n    grid-template-columns: 310px 1fr;\n    height: 100%;\n    margin-top: 5px;\n    gap: 12px;\n  }\n}\n.__search__filters{\n  box-shadow: 0px 4.8px 14.4px rgba(0, 0, 0, 0.18);\n  border-radius: 4px;\n  text-align: left;\n  height: fit-content;\n  background: #ffffff;\n  padding-bottom: 8px;\n}\n.__search__grid{\n  box-shadow: 0px 4.8px 14.4px rgba(0, 0, 0, 0.18);\n  border-radius: 4px;\n  text-align: left;\n  height: fit-content;\n  overflow-x: auto;\n  overflow-y: hidden;\n  background: #ffffff;\n  min-width: 0;\n}\n.__search__grid--container{\n  padding-bottom: 1px;\n}\n.__search__grid--container-title{\n  font-weight: 600;\n  font-size: var(--title);\n  line-height: 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  color: #000;\n  margin: 0;\n  padding: 10px 12px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.08);\n}\n@media (min-height: 768px) {\n  .__search__grid--container-title{\n    font-family: Segoe UI;\n    font-weight: 600;\n    font-size: var(--subheader);\n    line-height: 20px;\n    display: flex;\n    align-items: center;\n    color: #000;\n    margin: 0;\n    padding: 10px 12px;\n  }\n}\n.__search__grid--container-freeAcion{\n  display: flex;\n  align-items: flex-end;\n}\n.__search__grid--container-dateRange{\n  margin-right: 12px;\n  font-size: 16px;\n}\n.__search__grid--container__Grid{\n  height: 82%;\n  overflow: hidden;\n}\n@media (min-height: 768px) {\n  .__search__grid--container__Grid{\n    height: 92%;\n    overflow: hidden;\n  }\n}\n.dialog.delete-rule div {\n  position: static !important;\n  top: auto !important;\n  left: auto !important;\n}\n.dialog.delete-rule {\n  padding: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  min-height: 100vh;\n}\n.__search__circular {\n  color: var(--primary);\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  margin: -10px 0 0 -10px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
